import { render } from "./gsrcu0201.vue?vue&type=template&id=7273575d&scoped=true"
import script from "./gsrcu0201.vue?vue&type=script&lang=js"
export * from "./gsrcu0201.vue?vue&type=script&lang=js"

import "./gsrcu0201.vue?vue&type=style&index=0&id=7273575d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7273575d"]])

export default __exports__